<div class="settings-row-label">
    <slot />
</div>

<style>
    .settings-row-label {
        font-size: 1.2em;
        flex: 0.1 0 100px;
    }
</style>